<template>
  <div class="asc-custom-alerts-template">
    <template v-if="!isCustomAlertsActive">
      <asc-page-coming-soon
        label="Custom Alerts page Coming Soon!"
      ></asc-page-coming-soon>
    </template>
    <template v-if="isCustomAlertsActive">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <asc-custom-alerts-grid-wrapper
            :values="values"
            :shared-alerts="sharedAlerts"
            :hide-action-footer="hideActionFooter"
            :is-airline-user="isAirlineUser"
            :is-acmf-user="isAcmfUser"
            :user-airlines="userAirlines"
            :user="user"
            :custom-alerts-full-flight-simple-permission="
              customAlertsFullFlightSimplePermission
            "
            :custom-alerts-full-flight-advanced-permission="
              customAlertsFullFlightAdvancedPermission
            "
            :custom-alerts-acmf-simple-permission="
              customAlertsAcmfSimplePermission
            "
            :custom-alerts-acmf-advanced-permission="
              customAlertsAcmfAdvancedPermission
            "
            :custom-alerts-dplf-advanced-permission="
              customAlertsDplfAdvancedPermission
            "
            @openAlertTypeDialog="handleOpenAlertTypeDialog"
            @handleEditAlert="handleEditAlert"
            @onDeleteAlert="handleDeleteAlert"
            @toggleAlert="handleToggleAlert"
          ></asc-custom-alerts-grid-wrapper>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import AscPageComingSoon from '@/components/molecules/AscPageComingSoon'
import AscCustomAlertsGridWrapper from '@/components/organisms/AscCustomAlertsGridWrapper'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscCustomAlertsGridTemplate',

  components: {
    AscCustomAlertsGridWrapper,
    AscPageComingSoon,
  },

  props: {
    values: {
      type: Array,
      required: true,
      default: () => [],
    },
    sharedAlerts: {
      type: Array,
      default: () => [],
    },
    hideActionFooter: {
      type: Boolean,
      default: false,
    },
    isAirlineUser: {
      type: Boolean,
      default: false,
    },
    isAcmfUser: {
      type: Boolean,
      default: false,
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
    customAlertsFullFlightSimplePermission: {
      type: Boolean,
      default: false,
    },
    customAlertsFullFlightAdvancedPermission: {
      type: Boolean,
      default: false,
    },
    customAlertsAcmfSimplePermission: {
      type: Boolean,
      default: false,
    },
    customAlertsAcmfAdvancedPermission: {
      type: Boolean,
      default: false,
    },
    customAlertsDplfAdvancedPermission: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isCustomAlertsActive() {
      return AppFeatureFlags.getCustomAlertsPage()
    },
  },

  methods: {
    handleOpenAlertTypeDialog() {
      this.$emit('openAlertTypeDialog')
    },
    handleEditAlert(whichAlert) {
      this.$emit('handleEditAlert', whichAlert)
    },
    handleDeleteAlert(whichAlert) {
      this.$emit('onDeleteAlert', whichAlert)
    },
    handleToggleAlert(alert) {
      this.$emit('handleToggleAlert', alert)
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts-template {
  background-color: $gray-100;
  position: relative;
}
</style>
